import { render, staticRenderFns } from "./devicetenants.vue?vue&type=template&id=5200affb&"
import script from "./devicetenants.vue?vue&type=script&lang=ts&"
export * from "./devicetenants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "devicetenants.vue"
export default component.exports